import { render } from "./InfoStep.vue?vue&type=template&id=c3cf4e5a&scoped=true"
import script from "./InfoStep.vue?vue&type=script&lang=js"
export * from "./InfoStep.vue?vue&type=script&lang=js"

import "./InfoStep.vue?vue&type=style&index=0&id=c3cf4e5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c3cf4e5a"

export default script